module.exports = __webpack_public_path__ + "static/img/hky-1.6102de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/hky-1.png
// module id = qLFD
// module chunks = 15